import VErings from './src/main'

VErings.install = function(Vue) {
  Vue.component(VErings.name, VErings)
}

export default VErings
